import { forwardRef, HTMLAttributes } from "react";
import { cn } from "../../utils";

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: "xs" | "sm" | "md" | "lg";
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = "md", ...props }, ref) => {
    const sizeClasses = {
      xs: "al-h-3 al-w-3",
      sm: "al-h-4 al-w-4",
      md: "al-h-6 al-w-6",
      lg: "al-h-8 al-w-8",
    };

    return (
      <div
        ref={ref}
        className={cn(
          "al-animate-spin al-rounded-full al-border-2 al-border-gray-300 al-border-t-gray-600",
          sizeClasses[size],
          className,
        )}
        {...props}
      />
    );
  },
);

Spinner.displayName = "Spinner";
